import vehicleBadges from './vehicleBadges/vehicleBadgesSlice';

const root = {
	vehicleBadges
};

export default root;
